module.exports = __webpack_public_path__ + "img/icon-clipboard-grey.c6990ceb.svg";